export default __webpack_public_path__ + "static/media/gift.6f046eec.png";